/** Aviso global de cambios del carrito (para el contador del header). */
export const CART_EVENT = 'pizas-cart-change';

export function readCartCount() {
  try {
    const raw = sessionStorage.getItem('pizas_cart');
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list.reduce((s, c) => s + (Number(c.qty) || 0), 0) : 0;
  } catch {
    return 0;
  }
}

export function emitCartChange() {
  try {
    window.dispatchEvent(new CustomEvent(CART_EVENT, { detail: { count: readCartCount() } }));
  } catch {
    /* ignore */
  }
}
